<template>
    <div class="py-12" :class="backgroundColor" :data-testid="dataTestid">
        <TsSection>
            <TsTypography :append-class="isTextWhite ? 'text-white' : ''" as="h2">{{ heading }}</TsTypography>
            <TsCardOpinionProduct :banner-image="backgroundImage">
                <template #front>
                    <TsCarousel dataTestid="brand-details" snap-align="start" :breakpoints="{
                        240: {
                            itemsToShow: 4
                        },
                        425: {
                            itemsToShow: 6
                        },
                        700: {

                            itemsToShow: 7
                        }
                    }">
                        <Slide v-for="el in data" :key="el.id">
                            <TsCard append-class="bg-white">
                                <TsImage width="164" height="163" :src="el.image" loading="lazy"/>
                                <TsTypography weight="bold" append-class="mb-0" align="center" size="xs">{{ el.title }}
                                </TsTypography>
                            </TsCard>
                        </Slide>
                    </TsCarousel>
                </template>
            </TsCardOpinionProduct>
            <TsColumn class="is-7 mx-auto" v-if="description">
                <TsTypography :append-class="isTextWhite ? 'text-white' : 'text-black'" align="center">{{ description }}</TsTypography>
            </TsColumn>
            <TsColumn class="is-3 mx-auto" v-if="buttonLabel">
                <TsButton block :label="buttonLabel" />
            </TsColumn>
        </TsSection>
    </div>
</template>

<script setup lang="ts">

const TsCardOpinionProduct = defineAsyncComponent(
    () => import('~/components/organisms/TsCardOpinionProduct.vue')
);

const TsCarousel = defineAsyncComponent(
    () => import('~/components/organisms/TsCarousel.vue')
);

type Data = {
    id: number;
    image: string;
    title: string;
}

type Props = {
    heading: string;
    isTextWhite: boolean;
    backgroundImage: string;
    description: string;
    buttonLabel: string;
    backgroundColor: 'bg-dewalt' | 'bg-black';
    data: Data[];
    dataTestid?: string;
}

const props = withDefaults(defineProps<Props>(), {
    backgroundImage: '/images/accessoryBanner.webp',
    heading: 'Accessories',
    isTextWhite: false,
    backgroundColor: 'bg-dewalt',
    data: () => [
        { id: 1, title: 'Saw Blades', image: '/images/dewaltAccessory1.png' },
        { id: 2, title: 'Drill Battery', image: '/images/dewaltAccessory2.png' },
        { id: 3, title: 'Drill Battery', image: '/images/dewaltAccessory3.png' },
        { id: 4, title: 'NAil Tough', image: '/images/dewaltAccessory4.png' },
        { id: 5, title: 'Saw Blades', image: '/images/dewaltAccessory2.png' },
        { id: 6, title: 'Drill Battery', image: '/images/dewaltAccessory4.png' },
        { id: 7, title: 'Drill Battery', image: '/images/dewaltAccessory4.png' },
    ]
});
</script>
